import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import type {
    GenericResponse,
    ChangePinRequest,
    GetPinRequest,
    PinResponse
} from '@/features/card/types/card.types';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';



export const pinService = {
    async changePin(payload: ChangePinRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });

        const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.card.pinChange, { data: { data: payload } }, { headers: newHeaders });
        return response.data;
    },

    async getCardPin(request: GetPinRequest): Promise<PinResponse> {
        const newHeaders = buildCommonHeaders({
            withLocation: true
        });

        const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.card.pinGet, { data: { data: request } }, { headers: newHeaders });
        return response.data.data;
    }
};
